module.exports = __webpack_public_path__ + "assets/img/home-customer-choice-light-en.d0e12628.png";